import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  entityReducerMap,
  IEntityList,
  IEntityState,
  IFilteredLists,
  initialListState,
} from '../entity-data/entity-data.reducer';
import { EntityTypesEnum } from '../../app.enum';
import { List } from 'immutable';
import { ActionsEnum, SetCategories } from './expense-data.actions';
import { sortedUniqBy } from 'lodash';
import { DEFAULT_SEARCH_PARAMS } from './expense-data.data';

// feature name
export const FEATURE_NAME = 'expense-data';

// state interface
export interface IState extends IEntityState {
  categories: List<string>;
}

export const intialExpenseListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SEARCH_PARAMS,
};

// initial states of store
export const initialFilteredListsState: IFilteredLists = {
  all: intialExpenseListState,
  search: intialExpenseListState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  dispatchedResponse: null,
  categories: List([]),
};

// reducer
const reducerFn = handleActions(
  {
    ...entityReducerMap<IState>(),
    [ActionsEnum.SET_CATEGORIES]: function (
      state: IState,
      { payload }: SetCategories
    ): IState {
      const { categories } = payload;
      const currentCategories = state.categories || List([]);
      const newCategoriesSet = categories.toSet();
      const currentCategoriesSet = currentCategories.toSet();
      const sortedList = currentCategoriesSet
        .union(newCategoriesSet)
        .filter((x) => !!x)
        .toList()
        .sortBy((category) => category.toLowerCase());
      const uniqList: List<string> = List(
        sortedUniqBy(sortedList.toArray(), (category: string) =>
          category.toLowerCase()
        )
      );

      return {
        ...state,
        categories: uniqList,
      };
    },
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload && action.payload.entityType === EntityTypesEnum.expense
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export function getCategories() {
  return createSelector(selectFeature, (state: IState) => state.categories);
}
